import { InjectionToken } from '@angular/core';
import { JoinStateDetails } from '@app/app/shared/models';
import { ObservableResult } from '@app/app/shared/store';

export const JOIN_DATA_SERVICE = new InjectionToken<JoinDataService>('[Shared] JoinDataService');

/** What a learner can do about joining content; requesting a place also joins a waiting list when seats are taken. */
export type JoinAction = 'ENROL' | 'REGISTER' | 'WITHDRAW' | 'ACCEPT_SEAT' | 'DECLINE_SEAT' | 'ACCEPT_INVITATION' | 'DECLINE_INVITATION';

/**
 * A playlist is joined in the context it was opened from: `in` is the path of the playlists above it, as on the
 * playlist pages. Cards are joined on their own.
 */
export type JoinTarget = { kind: 'playlist'; uid: string; in?: string } | { kind: 'card'; id: string };

/** Each action answers with the learner's new join state. Refusals carry the API's reason (`FULL`, …), or none. */
export interface JoinDataService {
  act(target: JoinTarget, action: JoinAction): ObservableResult<JoinStateDetails>;

  /** The learner's join states on playlists listed without them, by playlist id; playlists not on v3 are left out. */
  joinStates(playlistUids: string[]): ObservableResult<Record<string, JoinStateDetails>>;
}
